import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '../lib/firebase'

Vue.use(Vuex)

import { Chat } from './modules/chat'
import { FrontChat } from './modules/frontchat'

export default new Vuex.Store({
  modules: { 
    Chat,
    FrontChat
  },
  
})
